"use client"

import Image from 'next/image'
import { React, useEffect } from 'react'
import styles from './css/cart.module.css'
import { useState, useContext } from 'react'
import { useGlobalContext } from '../../context/GlobalContextProvider'
import { Check, InfoIcon, Plus } from 'lucide-react'
import Spacer from '../AllPurpose/Spacer'
import { callLogUserEvent } from '@/app/_requests/userCalls'
import { Skeleton } from '@/components/ui/skeleton'

const RightOpenTicket = ({
    userID,
    ticket,
    addedToCart,
    setAddedToCart
}) => {

    const { cartTickets, setCartTickets } = useGlobalContext()

    const changeCartStatus = () => {

        // checks for null
        // (ensure it's an array)
        const safeCartTickets = Array.isArray(cartTickets) ? cartTickets : [];

        if (addedToCart) {
            // added to cart, so we remove below
            setCartTickets(safeCartTickets.filter(cartTicket => cartTicket.id !== ticket.id));

            callLogUserEvent({
                userID: userID,
                context: 'Ticket Scroll',
                decisionName: 'Removed ticket from cart',
                decisionDescription: 'used the checkbox',
                isMajorDecision: false,
                metadata: {
                    'ticketNumber': ticket.id
                }
            })

        } else {
            // not added to cart, so we add below
            // update the global context
            setCartTickets([...safeCartTickets, ticket])

            callLogUserEvent({
                userID: userID,
                context: 'Ticket Scroll',
                decisionName: 'Added ticket to cart',
                decisionDescription: 'used the checkbox',
                isMajorDecision: false,
                metadata: {
                    'ticketNumber': ticket.id
                }
            })

        }

        console.log(`changeCartStatus(), cartTickets:`, cartTickets)

        // changes state for UI
        setAddedToCart(!addedToCart)

    };

    // 'listener' in case add all to cart was clicked
    // in which case, we have to programmatically update the state instead of doing so in response to an 'add to cart' button click
    useEffect(() => {

        let ticketNumbersInCart = cartTickets.map((i) => i.ticket)

        if (ticketNumbersInCart.includes(ticket.ticket)) {
            // changes state for UI
            setAddedToCart(true)
        } else {
            setAddedToCart(false)
        }

    }, [cartTickets])

    return (
        <div className='flex flex-col items-end justify-end h-full py-[12px] w-[100px]'>

            <button
                onClick={changeCartStatus} className='flex items-center justify-center space-x-[7.5px]'>

                <h1 className={`text-gray-800 text-[18px] ${addedToCart ? 'font-tpBold' : 'animate-pulse-custom font-tpThin'}`}>
                    {addedToCart ? 'Selected' : 'Select'}
                </h1>

                <div
                    className={`min-w-[25px] h-[25px] rounded-[4px] border-[2px] border-gray-800 ${addedToCart ? 'animate-pop ' : 'animate-pulse-custom'}`}
                    style={{
                        backgroundColor: addedToCart ? '#1f2937' : '#ffffff',
                        transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out'
                    }}
                >

                    {addedToCart && (
                        <div className='flex flex-row items-center justify-center relative top-[2px]'>

                            <Check
                                color={'#ffffff'}
                                size={17}
                                strokeWidth={4}
                            />
                        </div>
                    )}

                </div>

            </button>

        </div>

    )
}

export default RightOpenTicket
